// patient
export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";

export const USER_LOGOUT = "USER_LOGOUT";

export const USER_DETAIL_RESET = "USER_DETAIL_RESET";
export const USERS_RESET = "USERS_RESET";

export const USER_ALL_REQUEST = "USER_ALL_REQUEST";
export const USER_ALL_SUCCESS = "USER_ALL_SUCCESS";
export const USER_ALL_FAIL = "USER_ALL_FAIL";

export const USERS_DELETE_REQUEST = "USERS_DELETE_REQUEST";
export const USERS_DELETE_SUCCESS = "USERS_DELETE_SUCCESS";
export const USERS_DELETE_FAIL = "USERS_DELETE_FAIL";

// users detail
export const USERS_DETAIL_REQUEST = "USERS_DETAIL_REQUEST";
export const USERS_DETAIL_SUCCESS = "USERS_DETAIL_SUCCESS";
export const USERS_DETAIL_FAIL = "USERS_DETAIL_FAIL";
export const USERS_DETAIL_RESET = "USERS_DETAIL_RESET";

export const USER_ADD_REQUEST = "USER_ADD_REQUEST";
export const USER_ADD_SUCCESS = "USER_ADD_SUCCESS";
export const USER_ADD_FAIL = "USER_ADD_FAIL";

export const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_FAIL = "USER_UPDATE_FAIL";
export const USER_UPDATE_RESET = "USER_UPDATE_RESET";

// medecin PS

export const MEDECIN_PS_LOGIN_REQUEST = "MEDECIN_PS_LOGIN_REQUEST";
export const MEDECIN_PS_LOGIN_SUCCESS = "MEDECIN_PS_LOGIN_SUCCESS";
export const MEDECIN_PS_LOGIN_FAIL = "MEDECIN_PS_LOGIN_FAIL";

export const MEDECIN_PS_LOGOUT = "MEDECIN_PS_LOGOUT";

export const MEDECIN_PS_DETAIL_RESET = "MEDECIN_PS_DETAIL_RESET";
export const MEDECIN_PS_RESET = "MEDECIN_PS_RESET";
